import styled from 'styled-components'
// views
import { ButtonWrapper } from 'components/UI/Button/IconButton/views'
// static
import ScheduleReviewIconOrigin from 'src/icons/schedule-review.svg'
// themes
import colors from 'themes/colors'
// utils
import { size } from 'polished'

export const Wrapper = styled.div``

export const TemplateSelectWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  > div:first-child {
    flex: 0.5;
    min-width: 50%;
  }

  ${ButtonWrapper} {
    min-height: 34px;
    min-width: 34px;
  }
`

export const ScheduleReviewIcon = styled(ScheduleReviewIconOrigin)`
  && {
    ${size('18px')};

    path {
      fill: ${colors.white};
    }
  }
`
